<template>
    <q-layout view="hHh lpR fFf" style="background-image: url('/img/web_back0509.jpg') ;">

        <q-header>
            <guest-toolbar />
        </q-header>

        <q-page-container>
            <child />
        </q-page-container>

    </q-layout>
</template>

<script>
    import GuestToolbar from '../components/GuestToolbar';

    export default {
        // name: 'guest',

        components: {
            GuestToolbar
        },
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/layouts/guest.vue